import {REPORT_EXPIRING_REWARDS} from '/enum/records.enum';

export default {
  reportName: REPORT_EXPIRING_REWARDS,
};
